import { cn } from '../../utils/cn.js';

/** A rail row is a full-width, left-aligned ghost `Button`; `active` marks the open conversation or dashboard. */
export function railRowClass(options: { active?: boolean; className?: string } = {}): string {
  return cn(
    'h-auto w-full min-w-0 justify-start gap-2 overflow-hidden rounded-[7px] px-2.5 py-[7px] text-left text-[13px] font-normal whitespace-nowrap',
    options.active ? 'bg-accent-muted text-accent-text' : 'text-muted hover:bg-surface hover:text-body',
    options.className,
  );
}
